export default "__VITE_ASSET__ahyGSAlO__"